import React, { useState, useEffect } from "react";
import AuthComponent from "../AppUser/Login/AuthComponent";
import { Link } from "react-router-dom";

const HomePage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Detect screen size change
  const handleResize = () => {
    setIsMobileOrTablet(window.innerWidth <= 992); // Changed from 768 to 992 (lg breakpoint)
  };

  useEffect(() => {
    // Initial check for screen size
    handleResize();
    
    // Listen to resize event
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const styles = {
    body: {
      backgroundColor: "#f8f9fa",
      fontFamily: "Arial, sans-serif",
      margin: 0,
      padding: 0,
    },
    navbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "15px 30px",
      backgroundColor: "#ffffff",
      borderBottom: "none",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      position: "relative",
      zIndex: 1000,
    },
    navLinks: {
      listStyle: "none",
      display: "flex",
      gap: "30px",
      margin: 0,
      padding: 0,
      alignItems: "center",
    },
    navItem: {
      textDecoration: "none",
      color: "#2c3e50",
      fontWeight: "500",
      fontSize: "15px",
      transition: "color 0.3s ease, transform 0.2s ease",
      position: "relative",
      padding: "8px 0",
    },
    navItemHover: {
      color: "#007bff",
    },
    hamburger: {
      display: isMobileOrTablet ? "flex" : "none", // Show hamburger from lg breakpoint (992px and below)
      flexDirection: "column",
      cursor: "pointer",
      padding: "10px",
      borderRadius: "4px",
      transition: "background-color 0.3s ease",
    },
    bar: {
      backgroundColor: "#2c3e50",
      height: "3px",
      width: "25px",
      margin: "3px 0",
      borderRadius: "2px",
      transition: "all 0.3s ease",
    },
    mobileMenu: {
      display: menuOpen ? "block" : "none",
      position: "absolute",
      top: "100%",
      left: "0",
      width: "100%",
      backgroundColor: "#ffffff",
      boxShadow: "0px 4px 15px rgba(0,0,0,0.15)",
      padding: "15px 0",
      textAlign: "center",
      zIndex: 999,
      borderRadius: "0 0 10px 10px",
    },
    mobileNavItem: {
      padding: "12px 20px",
      borderBottom: "1px solid #f0f0f0",
      transition: "background-color 0.3s ease",
    },
    container: {
      textAlign: "center",
      padding: "40px 20px",
    },
    heading: {
      fontSize: "28px",
      fontWeight: "bold",
      marginBottom: "20px",
      color: "#000",
    },
    paragraph: {
      fontSize: "16px",
      marginBottom: "30px",
      color: "#333",
    },
    row: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      flexWrap: "wrap",
    },
    card: {
      width: "250px",
      padding: "20px",
      borderRadius: "15px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      textAlign: "center",
      backgroundColor: "#fff",
    },
    cardTitle: {
      color: "#007bff",
      fontSize: "18px",
      marginBottom: "10px",
    },
    button: {
      backgroundColor: "#007bff",
      color: "#fff",
      padding: "10px 15px",
      border: "none",
      borderRadius: "5px",
      textDecoration: "none",
      display: "inline-block",
      fontWeight: "bold",
      cursor: "pointer",
    },
    downloadButton: {
      backgroundColor: "#4285f4",
      color: "#fff",
      padding: "10px 20px",
      border: "none",
      borderRadius: "50px",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: "14px",
      boxShadow: "0 4px 15px rgba(66, 133, 244, 0.3)",
      transition: "all 0.3s ease",
      whiteSpace: "nowrap",
    },
    downloadButtonHover: {
      backgroundColor: "#3367d6",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(66, 133, 244, 0.4)",
    },
    playstoreIcon: {
      width: "22px",
      height: "22px",
    },
    logo: {
      fontSize: "24px", 
      fontWeight: "700",
      color: "#2c3e50",
      textDecoration: "none",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    logoIcon: {
      width: "32px",
      height: "32px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
    },
    logoImage: {
      width: "32px",
      height: "32px",
      borderRadius: "8px",
      objectFit: "cover",
    },
    footer: {
      backgroundColor: "#343a40",
      color: "white",
      padding: "20px",
      textAlign: "center",
      marginTop: "40px",
    },
    desktopNav: {
      display: "flex",
    },
    mobileNav: {
      display: "none",
    },
  };

  return (
    <div style={styles.body}>
      <nav style={styles.navbar}>
        <Link to="/" style={styles.logo}>
          <div style={styles.logoIcon}>
            <img 
              src="/assets/img/app_logo.png" 
              alt="MastiShorts Logo" 
              style={styles.logoImage}
            />
          </div>
          MastiShortss
        </Link>

        {/* Hamburger Icon for Tablets and Mobile */}
        <div
          style={{ ...styles.hamburger, display: isMobileOrTablet ? "flex" : "none" }}
          onClick={toggleMenu}
        >
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
          <div style={styles.bar}></div>
        </div>

        {/* Desktop Navigation - Only for large screens */}
        {!isMobileOrTablet && <ul style={{ ...styles.navLinks, ...styles.desktopNav }}>
          <li>
            <a
              href="https://mastishortss.com/pricing"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Pricing
            </a>
          </li>
          <li>
            <a
              href="https://mastishortss.com/api/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Terms And Conditions
            </a>
          </li>
          <li>
            <a
              href="https://mastishortss.com/api/privacypolicy"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Privacy Policy
            </a>
          </li>
          <li>
            <a
              href="https://mastishortss.com/api/cancellationandrefund"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Refund Policy
            </a>
          </li>
          <li>
            <a
              href="https://mastishortss.com/api/contactus"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Contact Us
            </a>
          </li>
          <li>
            <a
              href="https://play.google.com/store/apps/details?id=com.mastiindia&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.downloadButton}
            >
              <svg style={styles.playstoreIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.92 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              Download App
            </a>
          </li>
        </ul>}

        {/* Mobile Menu - Shows for tablets and mobile */}
      {isMobileOrTablet &&  <ul style={styles.mobileMenu}>
          <li style={styles.mobileNavItem}>
            <a
              href="https://mastishortss.com/pricing"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Pricing
            </a>
          </li>
          <li style={styles.mobileNavItem}>
            <a
              href="https://mastishortss.com/api/termsandconditions"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Terms & Conditions
            </a>
          </li>
          <li style={styles.mobileNavItem}>
            <a
              href="https://mastishortss.com/api/privacypolicy"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Privacy Policy
            </a>
          </li>
          <li style={styles.mobileNavItem}>
            <a
              href="https://mastishortss.com/api/cancellationandrefund"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Refund Policy
            </a>
          </li>
          <li style={styles.mobileNavItem}>
            <a
              href="https://mastishortss.com/api/contactus"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.navItem}
            >
              Contact Us
            </a>
          </li>
          <li style={styles.mobileNavItem}>
            <a
              href="https://play.google.com/store/apps/details?id=com.mastiindia&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              style={{...styles.downloadButton, justifyContent: "center", margin: "10px auto", width: "fit-content"}}
            >
              <svg style={styles.playstoreIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.92 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              Download App
            </a>
          </li>
        </ul>}
      </nav>

      <div style={styles.container}>
        <h2 style={styles.heading}>
          Welcome to the MASTISHORTS TECHNOLOGY PRIVATE LIMITED
        </h2>
        <p style={styles.paragraph}>
          MastiShorts application is an Indian application. MastiShorts application has
          brought great features and policies for all broadcasters. Here you can
          earn a lot of money by doing live stream.
        </p>
        <AuthComponent/>
        <div style={styles.row}>
          {[{ title: "Bd Panel", link: `/bd` }, { title: "Agency Admin Panel", link: `/agencyadmin` }, { title: "Agency Panel", link:`/agency` }, { title: "Coin Panel", link: `/coin` }].map((panel, index) => (
            <div key={index} style={styles.card}>
              <h5 style={styles.cardTitle}>{panel.title}</h5>
              <Link target="__blank" to={panel.link} style={styles.button}>Go to {panel.title}</Link>
            </div>
          ))}
        </div>
      </div>

      <footer style={styles.footer}>
        <p>© 2024-25 MASTISHORTS TECHNOLOGY PRIVATE LIMITED. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
